import { API_URL, postRequest } from '@/assets/ts/helpers/api';
function loginAdministrator(authData) {
    return postRequest(`${API_URL}/auth/login`, authData);
}
export { loginAdministrator };
